import type { Point2d, Rectangle2d } from ".."

export const isPointInBox = (point: Point2d, box: Rectangle2d): boolean => {
  const { x, y } = point
  const { x: bx, y: by, w, h } = box

  return x >= bx && x <= bx + w && y >= by && y <= by + h
}
